import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import hhPurpleLogo from "./img/hhPurpleLogo.png";
import otbLogo from "./img/otbLogo.png";
import { Wrapper, Container, Logo } from "./styles/portal-header-banner-styles";

interface IHiringHubHeaderProps {
  color: string;
  otb?: boolean;
}

const HiringHubHeader: FunctionComponent<IHiringHubHeaderProps> = ({
  color,
  otb,
}) => (
  <Wrapper>
    <CSSTransition in appear timeout={300} classNames="fade">
      <Container>
        {color === "purple" && (
          <Logo src={hhPurpleLogo as string} alt="Hiring Hub Logo" />
        )}
        {otb && <Logo src={otbLogo as string} alt="OTB Logo" />}
      </Container>
    </CSSTransition>
  </Wrapper>
);

HiringHubHeader.propTypes = {
  otb: PropTypes.bool,
  color: PropTypes.string.isRequired,
};

HiringHubHeader.defaultProps = {
  otb: null,
};

export default HiringHubHeader;
